import { prompt, type PromptDefinition } from './models';

export const CONVEYANCER_PROMPTS = [
    prompt(
        'Meet obligations',
        "Which title and plan documents are available for this building's transfer?",
        'Which buildings are missing title or plan documents for transfer?'
    ),
    prompt(
        'Meet obligations',
        "What encumbrances are recorded in this building's available title documents?",
        'Which buildings have documented encumbrances needing conveyancing follow-up?'
    ),
    prompt(
        'Meet obligations',
        "Which approvals and occupancy records support this building's sale documents?",
        'Which buildings have missing approval or occupancy evidence for sale?'
    ),
    prompt(
        'Meet obligations',
        'Find conveyancing documents for this building relating to…',
        'Find conveyancing documents across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Meet obligations',
        "Do the property identifiers agree across this building's transfer documents?",
        'Which buildings have inconsistent identifiers across transfer documents?'
    ),
    prompt(
        'Meet obligations',
        "What outstanding notices appear in this building's sale-related records?",
        'Which buildings have outstanding notices to resolve before settlement review?'
    ),
    prompt(
        'Meet obligations',
        "What does this building's contract of sale say about settlement conditions?",
        'Which buildings have settlement conditions requiring further evidence?'
    ),
    prompt(
        'Meet obligations',
        'Find settlement conditions for this building concerning…',
        'Find settlement conditions across my buildings concerning…',
        'prefill'
    ),
    prompt(
        'Meet obligations',
        'Which strata disclosure documents are available for this building?',
        'Which buildings have gaps in their strata disclosure documents?'
    ),
    prompt(
        'Meet obligations',
        "What certificates or searches in this building's file may need updating?",
        'Which buildings have the oldest certificates or searches in their conveyancing files?'
    ),
    prompt(
        'Meet obligations',
        "What remains unanswered in this building's pre-settlement correspondence?",
        'Which buildings have unanswered pre-settlement enquiries?'
    ),
    prompt(
        'Meet obligations',
        "Check this building's sale disclosure evidence for…",
        'Compare sale disclosure evidence across my buildings for…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
